import { useTranslation } from 'react-i18next';
import { Button, Chat3LineIcon, Text } from 'ui';

type P = {
  count: number;
  onShowComments?: () => void;
};

const CommentCount = ({ count, onShowComments }: P) => {
  const { t } = useTranslation();
  return (
    <Button icon={<Chat3LineIcon size="extra-small" />} onClick={onShowComments} size="large" type="text">
      <Text size="small" type="secondary">
        {t('commentsCount', { count })}
      </Text>
    </Button>
  );
};

export default CommentCount;
